import { createReducer, on, Action } from '@ngrx/store';
import {SportEventState} from "./sport-events.model";
import {callSportEvents, successSportEvent, failSportEvent, partialSpUpdate} from "./sport-events.actions";
import * as _ from "lodash-es";

export const initialState: SportEventState = {
  sportEvent: undefined,
  sportEventLoading: false,
  sportEventLoaded: false
}

const reducer = createReducer(
  initialState,
  on(callSportEvents, (state, action) => {
    return {
      ...state,
      sportEvent: undefined,
      sportEventLoading: true,
      sportEventLoaded: false
    }
  }),
  on(successSportEvent, (state, action) => {
    return {
      ...state,
      sportEvent: action.sport_event,
      sportEventLoading: false,
      sportEventLoaded: true
    }
  }),
  on(failSportEvent, (state, action) => {
    return {
      ...state,
      sportEvent: undefined,
      sportEventLoading: false,
      sportEventLoaded: false
    }
  }),
  on(partialSpUpdate, (state, action ) => {
    // Safety check: ensure action.event exists and matches a function in ws
    const handler = action.event ? ws[action.event] : undefined;
    if (typeof handler === 'function') {
      return handler(state, action);
    }
    return state;
  }),
)

type WsHandlers = {
  RELOAD_EVENTS: string[];
  [key: string]: ((state: SportEventState, action: any) => any) | string[];
};

export const ws: WsHandlers = {
  SPORT_EVENT_UPDATE: (state: SportEventState, action): any => {
    const newData = action.data;

    if (!state.sportEvent || !Array.isArray(state.sportEvent)) {
      return state;
    }

    // Use .map to create a NEW array reference
    const updatedEvents = state.sportEvent.map((event: any) => {
      // If this is the event being updated, return a NEW object reference
      if (Number(event.id) === Number(newData.data.id)) {
        const updated = {
          ...event,
          period: newData.data.period,
          status: newData.data.status,
          add_info_json: {
            ...event.add_info_json,
            away_score: newData.data.add_info_json.away_score,
            home_score: newData.data.add_info_json.home_score,
            current_score: newData.data.add_info_json.current_score,
            result_code: newData.data.add_info_json.result_code
          }
        };
        return updated;
      }
      // Otherwise return the original object reference
      return event;
    });

    return {
      ...state,
      sportEvent: updatedEvents // Returning a new array reference triggers the selector
    };
  },
  RELOAD_EVENTS: []
}

export function sportEventReducer(
  state: SportEventState | undefined,
  action: Action
) : SportEventState {
  return reducer(state, action);
}
